'use client';

import { ReactNode, useEffect, useRef, useState } from 'react';

// Added isMenuOpen prop
const HeaderClient = ({ children, isMenuOpen }: { children: ReactNode; isMenuOpen?: boolean }) => {
  const headerRef = useRef<HTMLDivElement>(null);
  const [headerHeight, setHeaderHeight] = useState(0);

  useEffect(() => {
    const updateHeight = () => {
      if (headerRef.current) {
        setHeaderHeight(headerRef.current.offsetHeight);
      }
    };

    const timer = setTimeout(updateHeight, 100);
    
    const handleScroll = () => {
      if (!headerRef.current) return;
      if (window.scrollY > 80) {
        headerRef.current.classList.add('is-scrolled');
      } else {
        headerRef.current.classList.remove('is-scrolled');
      }
    };

    window.addEventListener('scroll', handleScroll, { passive: true });
    window.addEventListener('resize', updateHeight);

    return () => {
      window.removeEventListener('scroll', handleScroll);
      window.removeEventListener('resize', updateHeight);
      clearTimeout(timer);
    };
  }, []);

  return (
    <>
      <div 
        className="header-placeholder" 
        style={{ height: `${headerHeight}px` }} 
      />
      
      {/* FIX: Apply is-menu-open class directly to the fixed wrapper */}
      <div 
        ref={headerRef} 
        className={`header-fixed-wrapper ${isMenuOpen ? 'is-menu-open' : ''}`}
      >
        {children}
      </div>
    </>
  );
};

export default HeaderClient;